export const AllowAddTitleGroup = {
	All: 'all',
	Admins: 'admins',
	None: 'none',
};
